import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'
import withState from 'recompose/withState'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as ClassificationSelectors from 'app/modules/classification/selectors'
import { makeHasGate } from 'app/modules/gates/selectors'

import GoalActionModal from './component'
import { ActionViewConfig } from 'app/modules/playbook/constants'

const mapStateToProps = state => ({
  goal: PlaybookSelectors.currentGoal(state),
  classificationOptions: ClassificationSelectors.classificationOptions(state),
  selectedGoalAction: PlaybookSelectors.selectedGoalAction(state),
  hasCalendarAction: PlaybookSelectors.hasCalendarAction(state),
  hasAutoCloseAction: PlaybookSelectors.hasAutoCloseAction(state),
  isLeadBotPlaybook: PlaybookSelectors.isLeadBot(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      hideGoalActionModal: PlaybookActions.hideGoalActionModal,
      selectGoalAction: PlaybookActions.selectGoalAction,
      saveGoalAction: PlaybookActions.saveGoalAction,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('viewMode', 'setViewMode', null),
  withProps(props => ({
    isCalendarSelected: _.has(props.selectedGoalAction, 'schedule'),
    isMessageSelected: _.has(props.selectedGoalAction, 'message'),
    isAutoCloseSelected: _.has(props.selectedGoalAction, 'statusChange'),
    isCqlSelected: _.has(props.selectedGoalAction, 'markCQL'),
    disableCalendar: props.goal.get('schedule'),
    disableMessage: props.goal.get('message'),
    disableAutoClose: props.goal.get('statusChange'),
    classificationDetails: props.classificationOptions.find(
      classification => classification.value === props.goal.classification.get('classificationId')
    ),
  })),
  withHandlers({
    onCloseClick: props => () => {
      const {
        goal: { id },
        actions: { saveGoalAction, hideGoalActionModal },
        selectedGoalAction,
      } = props
      if (!!selectedGoalAction) saveGoalAction({ goalId: id, goalAction: selectedGoalAction })
      hideGoalActionModal()
    },
    onCancelClick: props => () => {
      props.actions.hideGoalActionModal()
    },
    onResetViewClick: props => () => {
      props.setViewMode(null)
    },
    onConfigureCqlClick: props => () => {
      props.setViewMode(ActionViewConfig.CQL)
    },
    handleSelectCql: props => score => {
      const { actions: { selectGoalAction } } = props
      selectGoalAction({
        markCQL: { score },
      })
    },
    handleSelectCalendar: props => () => {
      const { actions: { selectGoalAction } } = props
      selectGoalAction({
        schedule: { calendarId: 'placeholder' },
      })
    },
    handleSelectMessage: props => () => {
      const { actions: { selectGoalAction } } = props
      selectGoalAction({
        message: { authorId: null, body: 'Thanks! See you again soon.' },
      })
    },
    handleSelectAutoClose: props => () => {
      const { actions: { selectGoalAction } } = props
      selectGoalAction({
        statusChange: { status: 'CLOSED' },
      })
    },
  })
)(GoalActionModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/GoalActionModal/index.js